<template>
  <el-container class="data-detail-wrip">
    <header>
      <img src="/static/images/icon-company.png">
      {{customerDetail.company_name}}
      <i class="iconfont icon-close" @click="closeDetail"></i>
    </header>
    <div class="tab-box">
      <div class="tab-item" :class="(tabType == 0)?'active':''" @click="dtlChange(0)"><span>客户资料</span></div>
      <div class="tab-item" :class="(tabType == 1)?'active':''" @click="dtlChange(1)"><span>功能清单</span></div>
      <div class="tab-item" :class="(tabType == 2)?'active':''" @click="dtlChange(2)"><span>本地监测</span></div>
      <div class="tab-item" :class="(tabType == 4)?'active':''" @click="dtlChange(4)" v-if="moduleIds.includes(22)"><span>运营管理</span></div>
      <div class="tab-item" :class="(tabType == 3)?'active':''" @click="dtlChange(3)"><span>操作记录</span></div>
    </div>
    <div class="head" v-if="tabType == 0">
      <span>基本信息</span>
      <el-dropdown trigger="click" @command="handleCommand" v-if="funAuth.includes(6) || funAuth.includes(7) || funAuth.includes(8) || funAuth.includes(9)">
        <span class="el-dropdown-link">
          <i class="el-icon-arrow-down el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1" v-if="funAuth.includes(7)">转为正式客户</el-dropdown-item>
          <el-dropdown-item command="2" v-if="funAuth.includes(8)">转移负责人</el-dropdown-item>
          <el-dropdown-item command="3" v-if="customerDetail.status == 1 && funAuth.includes(9)">启  用</el-dropdown-item>
          <el-dropdown-item command="3" v-if="customerDetail.status == 0 && funAuth.includes(9)">停  用</el-dropdown-item>
          <el-dropdown-item command="4" v-if="funAuth.includes(6)">删  除</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" @click="editCustomer" v-if="funAuth.includes(5)">编 辑</el-button>
    </div>
    <div class="head" v-if="tabType == 1">
      <span>功能清单</span>
    </div>
    <div class="head" v-if="tabType == 2">
      <span>本地监测</span>
    </div>
    <div class="head" v-if="tabType == 4">
      <span>运营管理</span>
      <el-input class="seach" size="small" v-model="searchInput" placeholder="功能名称" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
      <el-date-picker v-model="dataTime" size="small" type="date" placeholder="选择日期" value-format="timestamp" @change="queryDataembeddingpointList"></el-date-picker>
    </div>
    <div class="head" v-if="tabType == 3">
      <span>操作记录</span>
    </div>
    <div class="content">
      <el-collapse v-model="activeNames" v-if="tabType == 0">
        <el-collapse-item name="1">
          <template slot="title">
            <i class="iconfont icon-zhankai"></i>
            基本信息
          </template>
          <div class="form">
            <div class="item">
              <span class="title">客户编号</span>
              <div class="item-content">{{customerDetail.company_no}}</div>
            </div>
            <div class="item">
              <span class="title">客户名称</span>
              <div class="item-content">{{customerDetail.company_name}}</div>
            </div>
            <div class="item">
              <span class="title">客户姓名</span>
              <div class="item-content">{{customerDetail.user_name}}</div>
            </div>
            <div class="item">
              <span class="title">联系电话</span>
              <div class="item-content">{{customerDetail.phone}}</div>
            </div>
            <div class="item">
              <span class="title">部署方式</span>
              <div class="item-content">{{(customerDetail.deployment_type == 1) ? '本地初始化':'云服务初始化'}}</div>
            </div>
            <div class="item" v-if="customerDetail.deployment_type === '1'">
              <span class="title">域名地址</span>
              <div class="item-content">{{customerDetail.local_domain_address}}</div>
            </div>
            <!-- <div class="item" :class="{'single': customerDetail.database_url}" v-if="customerDetail.deployment_type === '1'">
              <span class="title">数据库地址</span>
              <div class="item-content">{{customerDetail.database_url}}</div>
            </div>
            <div class="item" v-if="customerDetail.deployment_type === '1'">
              <span class="title">数据库用户名</span>
              <div class="item-content">{{customerDetail.database_username}}</div>
            </div>
            <div class="item" v-if="customerDetail.deployment_type === '1'">
              <span class="title">数据库密码</span>
              <div class="item-content">{{customerDetail.database_passwd}}</div>
            </div> -->
            <div class="item">
              <span class="title">开通版本</span>
              <div class="item-content" v-text="editionInit(customerDetail.edition)"></div>
            </div>
            <div class="item">
              <span class="title">组件版本</span>
              <div class="item-content">{{customerDetail.cm_name}}</div>
            </div>
            <div class="item">
              <span class="title">开通坐席</span>
              <div class="item-content">{{customerDetail.allow_number}}</div>
            </div>
            <div class="item">
              <span class="title">套餐开始日期</span>
              <div class="item-content">{{customerDetail.start_time | formatDate('yyyy-MM-dd')}}</div>
            </div>
            <div class="item">
              <span class="title">套餐结束日期</span>
              <div class="item-content">{{customerDetail.end_time | formatDate('yyyy-MM-dd')}}</div>
            </div>
            <div class="item" v-if="customerDetail.deployment_type === '0'">
              <span class="title">附件空间</span>
              <div class="item-content">{{customerDetail.attachment_size}}GB</div>
            </div>
            <div class="item" v-if="customerDetail.deployment_type === '0'">
              <span class="title">总数据量</span>
              <div class="item-content">{{customerDetail.data_size}}条</div>
            </div>
            <div class="item">
              <span class="title">内部帐户</span>
              <div class="item-content">{{customerDetail.internal_account==1?'否':'是'}}</div>
            </div>
            <div class="item">
              <span class="title">邀请码</span>
              <div class="item-content">{{customerDetail.invite_code}}</div>
            </div>
            <div class="item">
              <span class="title">维护客服</span>
              <div class="item-content">{{customerDetail.customer_name}}</div>
            </div>
            <div class="item">
              <span class="title">客户状态</span>
              <div class="item-content">{{(customerDetail.status == 0 ? '启用':'停用')}}</div>
            </div>
            <div class="item single">
              <span class="title">备注</span>
              <div class="item-content">{{customerDetail.remark}}</div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <i class="iconfont icon-zhankai"></i>
            系统信息
          </template>
          <div class="form">
            <div class="item">
              <span class="title">创建人</span>
              <div class="item-content">{{customerDetail.create_by}}</div>
            </div>
            <div class="item">
              <span class="title">创建时间</span>
              <div class="item-content">{{customerDetail.create_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
            </div>
            <div class="item">
              <span class="title">修改人</span>
              <div class="item-content">{{customerDetail.modify_by}}</div>
            </div>
            <div class="item">
              <span class="title">修改时间</span>
              <div class="item-content">{{customerDetail.modify_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <feature-list v-if="tabType == 1" :featureData="featureData"></feature-list>
      <el-table class="el-table-02" :data='tableList' tooltip-effect='dark' style='width: 100%;' v-if="tabType == 2">
        <el-table-column prop='company_name' label='客户名称'></el-table-column>
        <el-table-column label='监测时间'>
          <template slot-scope='scope'>{{ scope.row.monitor_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
        </el-table-column>
        <el-table-column label='监测状态'>
          <template slot-scope='scope'>{{ scope.row.monitor_state === '0' ? '正常' : '异常' }}</template>
        </el-table-column>
        <el-table-column prop='monitor_feedback' label='监测反馈'></el-table-column>
      </el-table>
      <el-table :data="tableList" tooltip-effect='dark' style='width: 100%;' class="el-table-02" v-if="tabType == 4">
        <el-table-column prop='company_name' label="客户名称" min-width="140" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="操作时间" min-width="140">
          <template slot-scope='scope'>{{ scope.row.operation_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
        </el-table-column>
        <el-table-column prop="function_name" label="埋点功能名称" min-width="140" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="phone" label="手机号码" min-width="120"></el-table-column>
        <el-table-column prop="operation_count" label="数量" min-width="90"></el-table-column>
        <el-table-column prop="operation_content" label="内容" min-width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ip" label="IP" min-width="100"></el-table-column>
      </el-table>
      <el-pagination v-if="tabType == 2 || tabType == 4" @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>
      <div class="log-box" v-if="tabType == 3">
        <div class="log-item" v-for="(date, index) in logList" :key="index">
          <div class="line">
            <div class="circle"></div>
          </div>
          <div class="rihgt">
            <div class="time">{{date.datetime_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
            <div class="content">{{date.content}}</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="转移负责人" :visible.sync="dialogTransfer" class="add-box" append-to-body>
      <div class="form-item">
        <span class="item-title">转移给</span>
        <div class="item-right">
          <el-select v-model="transferOfficer" placeholder="请选择">
            <el-option v-for="item in userList" :key="item.id" :label="item.user_name" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTransfer = false">取 消</el-button>
        <el-button type="primary" @click="transfer">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogStatus" class="prompt-box" append-to-body>
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">{{(customerDetail.status == 0) ? '停用':'启用'}}</div>
      <div class="note" v-if="customerDetail.status == 0">停用后该客户里的所有账号将不允许登录和使用系统。</div>
      <div style="margin-top: 20px;" v-else></div>
      <div class="prompt">{{(customerDetail.status == 0) ? '你确定要停用该公司账号吗？':'你确定要启用该公司账号吗？'}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogStatus = false">取 消</el-button>
        <el-button type="primary" @click="userStatus">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogDelete" class="prompt-box" append-to-body>
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <div class="note">删除后该公司所有登录账号与前台数据将会从数据库中完全移除且不可恢复。</div>
      <div class="prompt">你确定要删除该公司账号吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelete = false">取 消</el-button>
        <el-button type="primary" @click="userDelete">确 定</el-button>
      </span>
    </el-dialog>
    <div class="mask n1" v-if="dialogAdd" @click="dialogAdd = false"></div>
    <transition name="slide">
      <customer-add v-if="dialogAdd" :customer="customerDetail"></customer-add>
    </transition>
  </el-container>
</template>
<script>
import {HTTPServer} from '@/common/js/ajax.js'
import customerAdd from '@/common/components/customer-add'// 新增
import featureList from '@/common/components/feature-list'// 功能清单
import mixin from '@/common/js/mixins.js'
import tool from '@/common/js/tool.js'
export default {
  data () {
    return {
      defaultMsg: '<b>试用客户</b>',
      dialogDelete: false,
      disabled: true,
      dialogCusDetail: false,
      customerDetail: this.customer,
      tabType: 0,
      activeNames: ['1', '2', '3'],
      logList: [],
      dialogAdd: false,
      transferOfficer: null,
      userList: [],
      dialogTransfer: false,
      saveAddData: {},
      tableList: [],
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      dialogStatus: false,
      searchInput: '',
      dataTime: ''
    }
  },
  props: ['customer'],
  mixins: [mixin],
  mounted () {
    this.queryUserList()
    this.queryAllChargingStrategy()
    this.queryFchBtnAuth(({moduleId: 1}))
    // 关闭添加窗口
    this.$bus.on('closeAddModal', (value) => {
      if (value) {
        this.dialogAdd = false
      }
    })
    /** 添加、编辑客户 */
    this.$bus.on('saveAddModal', (jsondata, type) => {
      this.saveAddData = {
        jsondata: jsondata,
        type: type
      }
    })
  },
  components: {
    customerAdd,
    featureList
  },
  watch: {
    // 监听路由变化
    customer (data) {
      console.log('watch', this.customerDetail)
      this.customerDetail = JSON.parse(JSON.stringify(this.customer))
    },
    saveAddData () {
      if (this.saveAddData.type === 2) {
        this.editTrialUser(this.saveAddData.jsondata)
      } else if (this.saveAddData.type === 3) {
        this.updateTrialToFormalUser(this.saveAddData.jsondata)
      }
    }
  },
  methods: {
    /** 详情导航切换 */
    dtlChange (type) {
      this.tabType = type
      if (type === 1) {
        this.queryCommodityList({'userId': this.customerDetail.id})
      } else if (type === 2) {
        this.pageNum = 1
        this.pageSize = 20
        this.getLocalMonitorList()
      } else if (type === 3) {
        this.queryRecordList({moduleType: 1, moduleId: this.customerDetail.id})
      } else if (type === 4) {
        this.queryDataembeddingpointList()
      }
    },
    /** 点击菜单项触发的事件回调 */
    handleCommand (command) {
      if (command === '1') {
        this.dialogAdd = true
        this.customerDetail.addType = 3
      } else if (command === '2') {
        this.dialogTransfer = true
        this.transferOfficer = this.customerDetail.customer_id
      } else if (command === '3') {
        this.dialogStatus = true
      } else if (command === '4') {
        this.dialogDelete = true
      }
    },
    /** 编辑客户 */
    editCustomer () {
      this.dialogAdd = true
      this.customerDetail.addType = 2
    },
    /** 保存-编辑客户 */
    editTrialUser (jsondata) {
      let obj = JSON.parse(JSON.stringify(jsondata))
      delete obj.cm_name
      HTTPServer.editTrialUser(obj, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '保存成功！',
          type: 'success'
        })
        if (this.customerDetail.edition !== jsondata.edition && this.$route.name === 'Strategy') {
          this.$bus.emit('query-strategy-list', true)
        }
        this.customerDetail.company_name = jsondata.company_name
        this.customerDetail.user_name = jsondata.user_name
        this.customerDetail.phone = jsondata.phone
        this.customerDetail.edition = jsondata.edition
        this.customerDetail.cm_id = jsondata.cm_id
        this.customerDetail.cm_name = jsondata.cm_name
        this.customerDetail.allow_number = jsondata.allow_number
        this.customerDetail.start_time = jsondata.start_time
        this.customerDetail.end_time = jsondata.end_time
        this.customerDetail.attachment_size = jsondata.attachment_size
        this.customerDetail.data_size = jsondata.data_size
        this.customerDetail.invite_code = jsondata.invite_code
        let contains = tool.contains(this.userList, 'id', jsondata, 'id')
        if (contains) {
          this.customerDetail.customer_id = contains.id
          this.customerDetail.customer_name = contains.user_name
        }
        this.customerDetail.remark = jsondata.remark
        this.customerDetail.modify_by = (JSON.parse(sessionStorage.getItem('userInfo'))).user_name
        this.customerDetail.modify_time = (new Date()).getTime()
        this.dialogAdd = false
        this.$bus.emit('query-trial-list', true)
      })
    },
    /** 转为正式客户 */
    updateTrialToFormalUser (jsondata) {
      HTTPServer.updateTrialToFormalUser(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '保存成功！',
          type: 'success'
        })
        this.dialogAdd = false
        this.$bus.emit('close-trial-detail', true)
        this.$bus.emit('query-trial-list', true, true)
      })
    },
    /** 获取列表 */
    queryUserList () {
      var jsondata = {'pageNum': 1, 'pageSize': 9999}
      HTTPServer.queryUserList(jsondata, 'Loading').then((res) => {
        this.userList = res.dataList
      })
    },
    /** 转移负责人 */
    transfer () {
      var jsondata = {'id': this.customerDetail.id, 'user_id': this.transferOfficer}
      HTTPServer.updateTrialCustomerUser(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        let contains = tool.contains(this.userList, 'id', this.transferOfficer)
        if (contains) {
          this.customerDetail.customer_id = contains.id
          this.customerDetail.customer_name = contains.user_name
        }
        this.customerDetail.modify_by = (JSON.parse(sessionStorage.getItem('userInfo'))).user_name
        this.customerDetail.modify_time = (new Date()).getTime()
        this.dialogTransfer = false
        this.$bus.emit('query-trial-list', true)
      })
    },
    /** 删除客户 */
    userDelete (id) {
      var jsondata = {'id': this.customerDetail.id}
      HTTPServer.delTrialUser(jsondata, 'Loading').then((res) => {
        this.dialogDelete = false
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.$bus.emit('close-trial-detail', true)
        this.$bus.emit('query-trial-list', true, true)
      })
    },
    /** 禁用/启用用户 */
    userStatus () {
      var jsondata = {id: this.customerDetail.id, status: (this.customerDetail.status === '0') ? '1' : '0'}
      HTTPServer.TenableDisableUser(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.customerDetail.modify_by = (JSON.parse(sessionStorage.getItem('userInfo'))).user_name
        this.customerDetail.modify_time = (new Date()).getTime()
        this.dialogStatus = false
        this.customerDetail.status = jsondata.status
        this.$bus.emit('query-trial-list', true)
      })
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      if (this.tabType === 2) {
        this.getLocalMonitorList()
      } else if (this.tabType === 4) {
        this.queryDataembeddingpointList()
      }
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      if (this.tabType === 2) {
        this.getLocalMonitorList()
      } else if (this.tabType === 4) {
        this.queryDataembeddingpointList()
      }
    },
    getLocalMonitorList () {
      HTTPServer.getLocalMonitorList({'pageNum': this.pageNum, 'pageSize': this.pageSize, 'user_id': this.customerDetail.company_id}, 'Loading').then((res) => {
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
      })
    },
    closeDetail () {
      this.$bus.emit('close-trial-detail', true)
    },
    /** 搜索 */
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.queryDataembeddingpointList()
    },
    /** 运营管理 */
    queryDataembeddingpointList () {
      var jsondata = {
        'pageNum': this.pageNum,
        'pageSize': this.pageSize,
        'queryWhere': {
          'keyword': this.searchValue,
          'companyId': this.customerDetail.company_id,
          'operationTime': {}
        }
      }
      if (this.dataTime) {
        jsondata.queryWhere.operationTime.startTime = this.dataTime
        jsondata.queryWhere.operationTime.endTime = this.dataTime + 86399999
      }
      console.log(jsondata)
      HTTPServer.queryDataembeddingpointList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/trial-detail.vue